<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <WdsButtonText @click="toggleShow">
    {{ $t('Edit') }}
  </WdsButtonText>
  <Teleport to="#modals">
    <CompanyRecruiterModal
      :show="show"
      :on-cancel="toggleShow"
      :on-confirm="onConfirm"
      :title="$t('Edit recruiter')"
      :name-disabled="true"
      :email-disabled="true"
      :message-disabled="true"
      :initial-name="name"
      :initial-email="email"
      :initial-fee="recruiterFee"
      :initial-ownership="recruiterOwnershipDays"
      :initial-tags="tags"
      :error-text="$t('An error occurred while trying to edit recruiter')"
    ></CompanyRecruiterModal>
  </Teleport>
</template>

<script>
import CompanyRecruiterModal from '@/components/Contacts/CompanyRecruiter/CompanyRecruiterModal.vue'
import { UpdateCompanyRecruiterMutation } from '@/components/Contacts/CompanyRecruiter/mutations/UpdateCompanyRecruiterMutation'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'

export default {
  components: { CompanyRecruiterModal },
  props: {
    companyRecruiterId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    recruiterFee: {
      type: Number,
      default: null,
    },
    recruiterOwnershipDays: {
      type: Number,
      default: null,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show
    },
    onConfirm(data) {
      const editCompanyRecruiterMutation = {
        mutation: UpdateCompanyRecruiterMutation,
        variables: {
          input: {
            id: this.companyRecruiterId,
            recruiterFee: data.recruiterFee,
            recruiterOwnershipDays: data.recruiterOwnershipDays,
            tags: data.tags,
          },
        },
        clientId: 'publicApi',
      }
      return publicApi
        .mutate(editCompanyRecruiterMutation)
        .then((result) => result)
        .catch((error) => {
          throw error
        })
    },
  },
}
</script>
